import {Component} from '@angular/core';

@Component({
  selector: 'tag-ico',
  templateUrl: './tag-ico.component.html'
})
export class TagIcoComponent {
}
